export default __webpack_public_path__ + "static/media/IMG_1822cropped.66c03fec.jpeg";